import React from 'react';
import './custom.css';

function Bottom() {
  return (
    <footer className='bottom'>
      <p>&copy; {new Date().getFullYear()} Tanzania Police Force | All rights reserved.</p>
    </footer>
  );
}

export default Bottom;